exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.fbb{\n    border-bottom: 1px solid #409EFF;\n    color: #409EFF;\n    padding-bottom: 0px;\n    width: 7px;\n}\n", "", {"version":3,"sources":["/Volumes/aigoWork/Workspace/ying-zheng/yz-server/front_end/jjj_shop_multi_shop/src/views/plus/assemble/active/index.vue"],"names":[],"mappings":";AACA;IACI,iCAAiC;IACjC,eAAe;IACf,oBAAoB;IACpB,WAAW;CACd","file":"index.vue","sourcesContent":["\n.fbb{\n    border-bottom: 1px solid #409EFF;\n    color: #409EFF;\n    padding-bottom: 0px;\n    width: 7px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-45bcd154","scoped":false,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/plus/assemble/active/index.vue
// module id = Gz+Y
// module chunks = 0